<template>
  <div>
    <v-card class="section">
      <h2 class="text-center mb-1" v-if="title" v-html="title"></h2>
      <slot></slot>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'FormSection',
  props: {
    title: {
      type: [String],
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.section {
  margin-bottom: 24px;
  background-color: $systemColor1 !important;
  border: 1px solid $secondary !important;
  border-bottom: none !important;
  line-height: 1.5 !important;

  .section__wrap {
    border-left: 1px solid $secondary;
    border-top: 1px solid $secondary;
    border-bottom: unset;
    border-right: unset;
    margin:-1px 0 0 -1px;
  }
}
</style>
